// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wVI0","tabsBox":"styles_tabsBox__3LQ_m","createButton":"styles_createButton__2VI_C"};